<script>
export const group = 'Full'
</script>

<script setup>
import Image from '../default/Image.vue'
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'

defineProps({
  item: Object,
})
</script>

<template>
  <ToFullBottomRight>
    <Image :item="item" />
  </ToFullBottomRight>
</template>
